import { useEffect } from "react";
import PostList from "../components/PostList";
import { useReveal } from "../hooks/useReveal";
import About from "../views/About";
import BuildLog from "../views/BuildLog";
import ContactForm from "../views/Contact";
import Home from "../views/Home";
import Projects from "../views/Projects";

function JournalSection() {
  const [ref, visible] = useReveal(0.1);

  return (
    <section
      ref={ref}
      className="w-full bg-orange-50 px-2 md:px-8 border-y-3 border-black"
    >
      <div className="max-w-[1500px] mx-auto py-20 px-4 md:px-12">
        <div
          className={`flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 ${visible ? "reveal-up" : "reveal-hidden"}`}
        >
          <div>
            <p className="text-2xl font-black uppercase tracking-tight">
              Technical Journal
              <span className="text-orange-600">.</span>
            </p>
            <div
              className={`w-16 h-1 bg-black mt-2 ${visible ? "line-grow delay-200" : "reveal-hidden"}`}
            />
          </div>
          <p className="text-sm text-gray-500 max-w-[400px]">
            Writing about my interests, ideas, and lessons learned along the
            way.
          </p>
        </div>

        <div className={visible ? "reveal-up delay-300" : "reveal-hidden"}>
          <PostList limit={4} />
        </div>

        <a
          href="/blog"
          className={`inline-block mt-8 px-6 py-2 border-3 border-black bg-white font-black uppercase text-sm tracking-wide shadow-[4px_4px_0px_0px_#000] hover:shadow-[4px_4px_0px_0px_#ea580c] hover:border-orange-600 transition-all duration-200 ${visible ? "reveal-up delay-500" : "reveal-hidden"}`}
        >
          Read all entries →
        </a>
      </div>
    </section>
  );
}

function HomePage() {
  useEffect(() => {
    document.title = "Matteo Aries — Fullstack Developer";
  }, []);

  return (
    <div className="flex flex-col gap-0">
      <Home />
      <About />
      <Projects />
      <BuildLog />
      <JournalSection />
      <ContactForm />
    </div>
  );
}

export default HomePage;
